module.exports = __webpack_public_path__ + "static/the-miracle-of-castel-di-sangro-a706bd4d6d134562498ab90a91d4d43a.jpg";